import { helpers } from 'veritone-redux-common';
import { Status } from './campaign/actions';
const { createReducer } = helpers;

export const namespace = 'campaignError';
export const GET_CAMPAIGN_ERROR_SAGA = `${namespace}/GET_CAMPAIGN_ERROR_SAGA`;
export const SET_CAMPAIGN_ERROR = `${namespace}/SET_CAMPAIGN_ERROR`;
export const SET_CAMPAIGN_ERROR_STATUS = `${namespace}/SET_CAMPAIGN_ERROR_STATUS`;
export const RESET_CAMPAIGN_ERROR = `${namespace}/RESET_CAMPAIGN_ERROR`;

const defaultState = {
  currentData: [],
  status: Status.INITIAL
};

const campaignErrorReducer = createReducer(defaultState, {
  [SET_CAMPAIGN_ERROR]: (state, action) => {
    const { currentData } = action.payload;
    return {
      ...state,
      currentData,
      status: Status.LOADED
    };
  },
  [SET_CAMPAIGN_ERROR_STATUS]: (state, action) => {
    const { status } = action.payload;
    return {
      ...state,
      status
    };
  },
  [RESET_CAMPAIGN_ERROR]: () => {
    return {
      ...defaultState
    };
  }
});

export const getCampaignErrorSaga = (advertiserId, campaignId) => ({
  type: GET_CAMPAIGN_ERROR_SAGA,
  payload: { advertiserId, campaignId }
});

export const setCampaignError = currentData => ({
  type: SET_CAMPAIGN_ERROR,
  payload: { currentData }
});

export const setCampaignErrorStatus = status => ({
  type: SET_CAMPAIGN_ERROR_STATUS,
  payload: { status }
});

export const resetCampaignError = () => ({
  type: RESET_CAMPAIGN_ERROR
});

export const selectCampaignErrorState = state => state[namespace];
export default campaignErrorReducer;
